
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 2v16h13V6.664L10.836 2H2.5zM1.013.513A1.75 1.75 0 012.25 0h9a1 1 0 01.707.293l5.25 5.25a1 1 0 01.293.707v12A1.75 1.75 0 0115.75 20H2.25A1.75 1.75 0 01.5 18.25V1.75c0-.464.184-.91.513-1.237z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.25 0a1 1 0 011 1v4.25h4.25a1 1 0 110 2h-5.25a1 1 0 01-1-1V1a1 1 0 011-1zM5 10.75a1 1 0 011-1h6a1 1 0 110 2H6a1 1 0 01-1-1zM5 13.75a1 1 0 011-1h6a1 1 0 110 2H6a1 1 0 01-1-1z","fill":"#282E3E"}})])
          )
        }
      }
    